<template>
  <div>
    <div class="mt-3 aulas-btns">
      <v-btn
        text
        icon
        :to="{ name: 'diario-escolar-parecer-descritivo-aee-acp', params: { ano, cdturma, disciplina, cdinstruc, tipoDeEnsino, AEEouACP } }">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card class="pa-3 mt-2">
      <form @submit.prevent="onSubmit">
        <div class="parecer-labels">
          <div><strong>Período Avaliativo: </strong> {{ periodoAvaliativo }}</div>
          <div class="mb-2"><strong>Aluno: </strong> {{ aluno }}</div>
            <div><strong>Responsáveis: </strong> {{  `${dadosAluno.nmpai}, ${dadosAluno.nmmae}, ${dadosAluno.nmfiliacao} ` }}</div>
            <div><strong>Data de Nascimento: </strong> {{  dadosAluno.dtnascim }}</div>
            <div><strong>Endereço: </strong> {{ `${dadosAluno.tplograd.toUpperCase()} ${dadosAluno.nmlogradm}, ${dadosAluno.nuimovel} ${dadosAluno.edcomplem} - ${dadosAluno.nmcidadem}` }}</div>
            <div><strong>Idade Atual: </strong> {{ dadosAluno.idade}}</div>
        </div>
        <div>
          <InputDate label="Data do Parecer" v-model="form.dataparecer" :v="$v.form.dataparecer" />
          <TextArea class="mt-3" label="Aspecto Comportamental" :rows="10" v-model="form.descricaoaspectocomportamental" :v="$v.form.descricaoaspectocomportamental"/>
          <TextArea class="mt-3" label="Percepção Visual e Memória Auditiva" :rows="10" v-model="form.descricaovisualeauditiva" :v="$v.form.descricaovisualeauditiva"/>
          <TextArea class="mt-3" label="Sistema de Leitura e Escrita" :rows="10" v-model="form.descricaoleituraescrita" :v="$v.form.descricaoleituraescrita"/>
          <TextArea class="mt-3" label="Raciocínio Lógico" :rows="10" v-model="form.descricaoraciociniologico" :v="$v.form.descricaoraciociniologico"/>
          <TextArea class="mt-3" label="Habilidades Motoras/Psicomotoras" :rows="10" v-model="form.descricaohabilimotoraspsicomotoras" :v="$v.form.descricaohabilimotoraspsicomotoras"/>
          <TextArea class="mt-3" label="Emocional/Afetivo/Social" :rows="10" v-model="form.descricaoemocionalafetivosocial" :v="$v.form.descricaoemocionalafetivosocial"/>
          <TextArea class="mt-3" label="Linguagem Oral" :rows="10" v-model="form.descricaoliguagemoral" :v="$v.form.descricaoliguagemoral"/>
          <TextArea class="mt-3" label="Estratégias Utilizadas" :rows="10" v-model="form.descricaoestrategiasutilizadas" :v="$v.form.descricaoestrategiasutilizadas"/>
          <TextArea class="mt-3" label="Observações" :rows="10" v-model="form.descricaoobservacao" :v="$v.form.descricaoobservacao"/>
          <div class="mt-3" style="text-align: right">
            <v-btn class="rounded-sm font-weight-regular me-2" type="submit" :loading="loading" small dark color="teal">Salvar</v-btn>
            <v-btn class="rounded-sm font-weight-regular" type="button" :loading="loading" small dark color="error" @click="excluir()" v-if="(acao === 'editar')">Excluir</v-btn>
            <v-btn class="rounded-sm font-weight-regular ms-2" type="button" :loading="loading" small dark color="teal" @click="replicarParaSemestreSeguinte()" v-if="(acao === 'editar') && cdpravadi === '13'">Replicar para semestre seguinte</v-btn>
          </div>
        </div>
      </form>
    </v-card>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0">
      <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
          <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store/index';
import { required, maxLength } from 'vuelidate/lib/validators';
import { alphaNumSpaceEnter } from '@/validations';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');


const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

const setFormInicial = (props) => {
  const dadosUsuario = dadosUser();
  return {
    aaletivo: props.ano,
    cdtipesc: dadosUsuario.cdtipesc,
    cdescola: dadosUsuario.cdescola,
    cdpessoal: dadosUsuario.cdpessoal,
    cdmatric: dadosUsuario.cdmatric,
    cdturma: props.cdturma,
    numatalun: props.numatalun,
    cdpravadi: props.cdpravadi,
    dataparecer: '',
    descricaoaspectocomportamental: '',
    descricaovisualeauditiva: '',
    descricaoleituraescrita: '',
    descricaoraciociniologico: '',
    descricaohabilimotoraspsicomotoras: '',
    descricaoemocionalafetivosocial: '',
    descricaoliguagemoral: '',
    descricaoestrategiasutilizadas: '',
    descricaoobservacao: '',
    dadosAlluno: [],


  }
};

export default {
  name: 'ParecerAEEACPCadastro',
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    cdinstruc: [Number],
    disciplina: [String, Number],
    numatalun: [String, Number],
    cdpravadi: [String, Number],
    tipoDeEnsino: [String],
    ultimoPeriodo: {
      type: Boolean,
      default: false,
    },
    AEEouACP: [Boolean]
  },
  data() {
    return {
      form: setFormInicial(this.$props),
      aluno: '',
      periodoAvaliativo: '',
      optionsSituacaoFinal: [
        { value: null, text: '' },
        { value: 'A', text: 'Aprovado' },
        { value: 'R', text: 'Reprovado' },
      ],
      loading: false,
      msgArrayError: [],
      submitText: '',
      snackbar: false,
      aaletivo: this.ano,
      codinstruc: this.cdinstruc,
      acao: '',
      dadosAluno: '',
    };
  },
  validations() {
    return {
      form: {
        aaletivo: { required },
        cdtipesc: { required },
        cdescola: { required },
        cdpessoal: { required },
        cdmatric: { required },
        cdturma: { required },
        numatalun: { required },
        cdpravadi: { required },
        dataparecer: { required, isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
        descricaoaspectocomportamental: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaovisualeauditiva: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaoleituraescrita: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaoraciociniologico: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaohabilimotoraspsicomotoras: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaoemocionalafetivosocial: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaoliguagemoral: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
        descricaoestrategiasutilizadas: { required, maxLength: maxLength(2000), alphaNumSpaceEnter },
      },
    };
  },
  async beforeRouteEnter(to, from, next){
    if(
      typeof to.params.ano === 'undefined' || typeof to.params.cdturma === 'undefined' || typeof to.params.disciplina === 'undefined'
      || typeof to.params.numatalun === 'numatalun' || typeof to.params.cdpravadi === 'cdpravadi'
    ){
      return next('/diario-escolar');
    }
    try {
      const { data } = await DiarioEscolarRepository.getParecerDescritivoAEEouACP({
        ...dadosUser(),
        aaletivo: to.params.ano,
        cdturma: to.params.cdturma,
        cddiscipl: to.params.disciplina,
        numatalun: to.params.numatalun,
        cdpravadi: to.params.cdpravadi,
      });
      return next(vm => {
        vm.load(data.results);
      });
    } catch(error) { }
  },
  methods: {
    load({ parecer, aluno, dspravadi, dataAtual, dadosAluno }) {
      this.form.dataparecer = moment(dataAtual, 'YYYY-MM-DD').format('DD/MM/YYYY');
      if(parecer) {
        this.form = { ...parecer,
                       dataparecer: moment(parecer.dataparecer, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                    };
        this.acao = 'editar';
      }
      else {
        this.acao = 'novo';
      }
      this.aluno = aluno;
      this.periodoAvaliativo = dspravadi;
      this.dadosAluno = dadosAluno;
      this.$Progress.finish();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        const form = {
          ...this.form,
          dataparecer: moment(this.form.dataparecer, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }
        const { data } = await DiarioEscolarRepository.postParecerDescritivoAEEouACP({
          data: form,
          aaletivo: this.aaletivo,
          cdinstruc: this.cdinstruc,
          cddiscipl: this.disciplina
          });

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.acao = 'editar';
        this.form = data.parecer;
        this.form.dataparecer = moment(data.parecer.dataparecer, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
      } finally {
        this.loading = false;
      }
    },
    async replicarParaSemestreSeguinte() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        const { data } = await DiarioEscolarRepository.postParecerDescritivoAEEouACP({
          data: {
            ...this.form,
            cdpravadi: '14',
            dataparecer: moment(this.form.dataparecer, 'DD/MM/YYYY').format('YYYY-MM-DD')
          },
          aaletivo: this.aaletivo,
          cdinstruc: this.cdinstruc,
          cddiscipl: this.disciplina
          });

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.$router.push({
          name: 'diario-escolar-parecer-descritivo-aee-acp',
          params: {
            ano: this.ano,
            cdturma: this.cdturma,
            disciplina: this.disciplina,
            cdinstruc: this.cdinstruc,
            tipoDeEnsino: this.tipoDeEnsino,
          },
        });
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
      } finally {
        this.loading = false;
      }
    },
    async excluir() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este parecer descritivo?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        const { data } = await DiarioEscolarRepository.deleteParecerDescritivoAEEouACP(this.form.identificadorpareceraeeacp);
        this.submitText = data.message;
        this.snackbar = true;

      }catch(error) {
        if(error.response) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }

      this.$router.push({ name: 'diario-escolar-parecer-descritivo-aee-acp',
                          params: {
                                    ano: this.ano,
                                    cdturma: this.cdturma,
                                    disciplina: this.disciplina,
                                    cdinstruc: this.cdinstruc,
                                    tipoDeEnsino: this.tipoDeEnsino
                                  }
                        });

    }
  },
}
</script>

<style lang="scss">
.parecer-labels {
  font-size: 15px;
  margin-bottom: 15px;
}
</style>
